module.exports = __webpack_public_path__ + "static/logo-no-text-abaa3f1994f9bf85f5b47cdb69d6b3ee.png";